import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-apidocumentation',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './apidocumentation.component.html',
  styleUrls: ['./apidocumentation.component.scss'],
})
export class ApidocumentationComponent implements OnInit, OnDestroy {
  public faAngle1 = faAngleRight;
  public faAngle2 = faAngleDown;
  public faAngle3 = faAngleDown;
  public faAngle4 = faAngleDown;
  public hideContaninerGet = false;
  public hideContaninerSchemas = true;
  public hideContaninerDescription = true;
  public hideContaninerAPIPackage = true;
  public selectedOption = false;
  public JsonExample = {
    packageId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    packageCode: 'string',
    barcode: 'string',
    barcodeSymbology: 'string',
    deliveryTypeName: 'string',
    deliveryTypeAddress: 'string',
    receptorName: 'string',
    packageNote: 'string',
    packageStatusName: 'string',
    creationDate: '2020-05-07T22:45:24.362Z',
    estimatedDeliveryDate: '2020-05-07T22:45:24.362Z',
    scannedInWarehouse: '2020-05-07T22:45:24.362Z',
    scannedOnRoute: '2020-05-07T22:45:24.362Z',
    deliveryDate: '2020-05-07T22:45:24.362Z',
    returnedDate: '2020-05-07T22:45:24.362Z',
    cancelledDate: '2020-05-07T22:45:24.362Z',
    deliveryPackagePhotoURL: 'string',
    amountReceived: 'string',
    deliveryDescription: 'string',
  };

  private previousLang!: string;
  private translate = inject(TranslateService);

  ngOnInit() {
    this.previousLang = this.translate.currentLang;
    this.translate.use('en');
  }

  toggleGet() {
    if (this.hideContaninerGet) {
      this.hideContaninerGet = false;
      this.faAngle1 = faAngleRight;
    } else {
      this.hideContaninerGet = true;
      this.faAngle1 = faAngleDown;
    }
  }

  toggleDescription() {
    if (this.hideContaninerDescription) {
      this.hideContaninerDescription = false;
      this.faAngle2 = faAngleRight;
    } else {
      this.hideContaninerDescription = true;
      this.faAngle2 = faAngleDown;
    }
  }

  toggleOption() {
    if (this.selectedOption) this.selectedOption = false;
    else this.selectedOption = true;
  }

  toggleSchemas() {
    if (this.hideContaninerSchemas) {
      this.hideContaninerSchemas = false;
      this.faAngle3 = faAngleRight;
    } else {
      this.hideContaninerSchemas = true;
      this.faAngle3 = faAngleDown;
    }
  }

  toggleApiPackage() {
    if (this.hideContaninerAPIPackage) {
      this.hideContaninerAPIPackage = false;
      this.faAngle4 = faAngleRight;
    } else {
      this.hideContaninerAPIPackage = true;
      this.faAngle4 = faAngleDown;
    }
  }

  ngOnDestroy() {
    this.translate.use(this.previousLang); // restore previous language when component destroyed
  }
}
